import Api from './Api'

const END_POINT = 'suppliers'

export default {
    async get_all(filters = null) {        
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request)
    },
    async get_allPaginated(filters = null) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}-list-paginated`, request);
    },
    async store(supplier) {
        return await Api.post(`${END_POINT}`, supplier)
    },
    async update(supplier) {
        return await Api.patch(`${END_POINT}/${supplier.id}`, supplier)
    },
    async change_status(supplier) {
        return await Api.patch(`${END_POINT}/${supplier.id}/change-status`, supplier)
    },
    async delete(supplier) {
        return await Api.delete(`${END_POINT}/${supplier.id}`, supplier)
    },
    download(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}/donwload`, request);
    },
}